<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->

<template>
  <div
      align="left"
      :class="{
        'ma-0': $vuetify.breakpoint.smAndDown,
        'ma-5': $vuetify.breakpoint.mdAndUp,
      }"
      xs12
      sm6
      md4
    >
    <notification-popup  
      :dialog="notifSuccess"
      :contentMsg="$t('')"
      :headerMsg="$t('Successfully')"
      :nameBtnNo="$t('labelNo')"
      :nameBtnYes="$t('Close')"
      disableBtnNo="true"
      colorIcon = "success"
      Icon="mdi-check-circle"
      :onHandlerYes="login"/>

    <notification-popup 
      :dialog="notifFailed"
      :contentMsg="$t('failed')"
      :headerMsg="$t('FailedSubmit')"
      :nameBtnNo="$t('labelNo')"
      :nameBtnYes="$t('Close')"
      colorIcon = "danger"
      typeModal="transaction"
      Icon="mdi-close-circle"
      disableBtnNo="true"
      :onHandlerYes="buttonCloseNotifPopup"/>
    
    <div class="body-login">
      <div align="left">
        <h3 class="h3-title">{{ $t("ResetPassword") }}</h3>
      </div>
      <v-form v-model="valid">
        <v-row align="center">
          <v-col cols="12" class="marginzero">
            <label class="label-content">{{ $t("email") }}</label>
            <v-text-field
              height="20"
              name="email"
              :color="$partnerACL.getButtonColor()"
              v-validate="'required|email'"
              :rules="[emailRules.required, emailRules.valid]"
              v-model="email"
              :placeholder="$t('e.g.') + ' johndoe@mail.com'"
              required
              dense
              outlined
            ></v-text-field>
          </v-col>

          <div class="footer justif-content-even mt-4">
            <ac-button 
              :outlined="true"
              :name="$t('Back')" 
              :on-click-handler="login"
              :width="'40%'"
            />
            <ac-button 
              :name="$t('Submit')" 
              :on-click-handler="submit"
              :width="'40%'"
            />
          </div>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import AcButton from "@/components/AcButton";
import NotificationPopup from "@/components/NotificationPopup.vue";
// import CheckBoxAc from "@/components/CheckBox"

export default {
  components: { NotificationPopup, AcButton },
  data() {
    return {
      notifSuccess: false,
      notifFailed: false,
      email: "",
      show: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 6 || "Min 6 characters",
        emailMatch: () => `Your email entered not match`,
      },
      valid: true,
      emailRules: {
        required: value => !!value || this.$t("EmailRequired"),
        valid: value => !value || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.$t("EmailValidation"),
      },
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "";
    },
  },
  methods: {
    submit() {
      //let self = this;
      const defaultLang = localStorage.getItem('language') || "en";
      let payload = {
        email: this.email,
        language: defaultLang
      };

      this.$store.dispatch("auth/forgetPassword", payload)
        .then(response => {
          if (response.status) {
            this.notifSuccess = true
          } else {
            this.notifFailed = true
          }
        })
    },
    login() {
      try {
        let loginUrl = this.$store.state.auth.initialPath.login
        this.$router.push({
          path: loginUrl,
          query: { partner_id: localStorage.getItem('partner_id') }
        });
      } catch (error) {
        this.$router.push({ path: '/login' })
      }
    },
    buttonCloseNotifPopup() {
      this.notifFailed = false
    }
  },
};
</script>

<style scoped>
.justif-content-even {
  justify-content: space-evenly !important;
}

/* If the screen size is 601px or more, set the font-size of <div> to 80px */
@media only screen and (min-width: 601px) {
  .marginzero {
    margin-bottom: -20px;
  }

  .body-login {
    /* position: fixed; */
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;
    padding-bottom: 30px;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}

/* If the screen max size is 600px, set the font-size of <div> to 80px */
@media only screen and (max-width: 600px) {
  .marginzero {
    margin-bottom: -20px;
  }

  .body-login {
    /* position: fixed; */
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;
    padding-bottom: 30px;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
</style>